const navConfig = [
    { id: 'c3', navLink: '/catalog/3', navTitle: 'Category 1' },
    { id: 'c17', navLink: '/catalog/17', navTitle: 'Category 2' },
    { id: 'c27', navLink: '/catalog/27', navTitle: 'Category 3' },
    { id: 'c28', navLink: '/catalog/28', navTitle: 'Category 4' },
    { id: 'c31', navLink: '/catalog/31', navTitle: 'Category 5' }
];

export default navConfig;



// WEBPACK FOOTER //
// ./src/constants/navigationConfig.js